import { useEffect, useState } from "react";
import Disclaimer from "components/functional/disclaimer";
import { NavLink } from "react-router";
import ToggleActions from "components/functional/toggle-actions";
import { useTranslation } from "react-i18next";
import styles from "./starter-card.module.css";
import instance from "services/api";
import { useNavigate } from "react-router";
import { permissionsService } from "services/permissions.service";
import Spinner from "components/functional/spinner";
import { Users, Settings } from "lucide-react";

const StarterCard = ({ team }) => {
  const [preferences, setPreferences] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPreferences = async () => {
      try {
        const response = await instance.get(
          `/team-preferences/${team.team_id}`
        );
        setPreferences(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPreferences();
  }, [team.team_id]);

  const actionsLink = {
    manage_teams: `/teams/${team.team_id}/management`,
    invite_members: `/teams/${team.team_id}/invite`,
    manage_preferences: `/teams/${team.team_id}/preferences`,
  };

  const actions = [
    {
      permission: "manage_team",
      label: t("teams.card.actions.manage_team"),
      icon: <Users size={16} className="icon icon-secondary" />,
      command: () => navigate(actionsLink.manage_teams),
    },
  ].filter((action) =>
    permissionsService.hasPermission(action.permission, team.team_id)
  );

  if (isLoading) {
    return <Spinner />; // Or a loading spinner
  }

  const canUpdatePreferences = permissionsService.hasPermission(
    "manage_preferences",
    team.team_id
  );

  return (
    <>
      <header className={`${styles.header} mb-32`}>
        <div className={styles.icon}>
          <p className="title-3-variant-low">{team.name[0]}</p>
        </div>
        <h2 className={`${styles.title} title-3-variant-low`}>{team.name}</h2>
        <Disclaimer status="start" />
      </header>
      {canUpdatePreferences ? (
        <section className={styles.starter}>
          <p className="title-3-variant-low">
            {preferences
              ? t("teams.starter-card.can-update-preferences.preferences-saved")
              : t("teams.starter-card.can-update-preferences.set-preferences")}
          </p>

          <div className={styles.actions}>
            <NavLink
              className={`${styles.link} title-3-variant-low`}
              to={actionsLink.manage_preferences}
            >
              {preferences
                ? t(
                    "teams.starter-card.can-update-preferences.modify-preferences"
                  )
                : t(
                    "teams.starter-card.can-update-preferences.enter-preferences"
                  )}
            </NavLink>
            <ToggleActions
              actions={actions}
              btn={{
                class: "btn--secondary",
                icon: <Settings size={20} className="icon icon-secondary" />,
              }}
            />
          </div>
        </section>
      ) : (
        <>
          <section className={styles.starter}>
            <p className="title-3-variant-low">
              {preferences
                ? t(
                    "teams.starter-card.cannot-update-preferences.captain-set-preferences"
                  )
                : t(
                    "teams.starter-card.cannot-update-preferences.wait-for-captain"
                  )}
            </p>
            <div className={styles["player-action"]}>
              <NavLink
                className={`${styles.link} title-3-variant-low`}
                to={actionsLink.invite_members}
              >
                {t(
                  "teams.starter-card.cannot-update-preferences.invite-players"
                )}
              </NavLink>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default StarterCard;
